import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { config } from '../../../../../../environments/config';
import { UploadFilesMedicalCaseEventService } from '../../../service/medical-cases-event/upload-files-medical-case-event.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';

@Component({
  selector: 'app-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent implements OnInit {
  @Input() medical_case_event_id: number;
  @Input() documents_input: any[];
  @Input() list_id_type: number;
  @Output() updateDocuments: EventEmitter<boolean> = new EventEmitter<boolean>();

  public apiUrl = config.API_ROOT;
  public loading_upload: boolean = false;
  public documents: any[] = [];
  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  
  @ViewChild('fileUpload') fileUpload: any;

  constructor(
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    public uploadFilesMedicalCaseEventService: UploadFilesMedicalCaseEventService,
    public translate: TranslateService,
  ) {

  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.documents = [];
    if(this.documents_input != undefined)
    {
      this.documents_input.forEach(element=>{
        if (element.medical_case_event_doc_type_id == this.list_id_type)
          this.documents.push(element);
      });
    }
  }

  public addAttachmentDocument(event) {
    this.loading_upload = true;
    this.translate.get('uploading').subscribe((res: string) => {
      this.notificationsService.growlNotify('info', res + '...');
    });
    let uploadedAttachment = [];
    for (const file of event.files) {
      uploadedAttachment.push(file);
    }
    
    this.promiseAttachment = this.uploadFilesMedicalCaseEventService.addAttachmentDocument(uploadedAttachment, this.medical_case_event_id, this.list_id_type).toPromise().then(
      response => {
        this.fileUpload.clear();
        this.loading_upload = false;
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
        this.updateDocuments.emit(true);
      },
      error => {
        this.loading_upload = false;
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public gotoAttachmentDocumentMedicalCaseEvent(id) {
    window.open(this.apiUrl + '/documents-medical-case/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public deleteAttachmentDocumentMedicalCaseEvent(id) {
    this.promiseAttachment = this.uploadFilesMedicalCaseEventService.deleteAttachmentDocument(id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
          
        });
        this.updateDocuments.emit(true);
      },
      error => {
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public findElement (list, search) {
    let find = -1;
    let itera = 0;
    list.forEach(element => {
      if (element.id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/medical-cases/upload-documents/upload-documents.component.ts